import { useMemo } from "react";
import Particles, { ParticlesProvider } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const initParticles = async (engine) => {
  await loadSlim(engine);
};

const ParticleCanvas = ({ className, reduced }) => {
  const options = useMemo(
    () => ({
      fullScreen: false,
      fpsLimit: 60,
      detectRetina: true,
      background: { color: { value: "transparent" } },
      interactivity: {
        events: {
          onHover: { enable: !reduced, mode: "bubble" },
          resize: { enable: true },
        },
        modes: {
          bubble: { distance: 150, size: 4.5, duration: 2, opacity: 1 },
        },
      },
      particles: {
        number: { value: 110, density: { enable: true, width: 1400, height: 900 } },
        color: { value: ["#8B5CF6", "#A78BFA", "#C4B5FD", "#FFFFFF"] },
        shape: { type: "circle" },
        opacity: {
          value: { min: 0.15, max: 0.9 },
          animation: { enable: !reduced, speed: 0.6, sync: false },
        },
        size: { value: { min: 0.4, max: 2.4 } },
        move: {
          enable: !reduced,
          speed: 0.35,
          direction: "none",
          random: true,
          straight: false,
          outModes: { default: "out" },
        },
        shadow: { enable: true, color: "#8B5CF6", blur: 6 },
        links: { enable: false },
      },
    }),
    [reduced]
  );

  return <Particles id="ulti-particles" className={className} options={options} />;
};

export const ParticleField = ({ className = "" }) => {
  const reduced =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  return (
    <ParticlesProvider init={initParticles}>
      <ParticleCanvas className={className} reduced={reduced} />
    </ParticlesProvider>
  );
};
